import * as React from 'react';
import { MdOutlineChatBubbleOutline, MdOutlineMarkEmailRead, MdWarningAmber, MdClose } from 'react-icons/md';
import Modal from '../Common/Modal';

export default function EndConversationModal({
	isOpen,
	onConfirm,
	onClose,
	isLoading = false,
	errorMessage = '',
	// Assistants without a summary-email endpoint hide the "Email me a summary" option.
	allowEmail = true,
}) {
	const [sendEmail, setSendEmail] = React.useState(false);

	React.useEffect(() => {
		if (isOpen) setSendEmail(false);
	}, [isOpen]);

	return (
		<Modal
			open={isOpen}
			onClose={() => {
				if (!isLoading) onClose?.();
			}}
			title="End this conversation?"
			subtitle="This will clear the current chat. You can always start a new one right after."
			icon={<MdWarningAmber size={24} />}
			size="md"
			closeOnBackdrop={!isLoading}
			footer={
				<div className="d-flex flex-column flex-md-row justify-content-end gap-2 w-100">
					<button
						type="button"
						className="btn btn-light px-3 border"
						onClick={onClose}
						disabled={isLoading}
					>
						Cancel
					</button>
					<button
						type="button"
						className="btn btn-danger px-3 d-inline-flex align-items-center justify-content-center gap-2"
						onClick={() => onConfirm?.(allowEmail && sendEmail)}
						disabled={isLoading}
					>
						{isLoading ? (
							<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
						) : (
							<MdClose size={18} />
						)}
						<span>
							{isLoading ? 'Ending…' : allowEmail && sendEmail ? 'End & Email Summary' : 'End Conversation'}
						</span>
					</button>
				</div>
			}
		>
			{errorMessage ? (
				<div className="alert alert-danger mb-3 rounded-3 px-3 py-2 d-flex align-items-center gap-2">
					<MdWarningAmber size={18} />
					<span className="small fw-semibold">{errorMessage}</span>
				</div>
			) : null}

			{allowEmail ? (
			<label
				className="d-flex align-items-start gap-3 rounded-3 border p-3 mb-2"
				style={{ cursor: isLoading ? 'default' : 'pointer' }}
			>
				<input
					type="checkbox"
					className="form-check-input mt-1"
					checked={sendEmail}
					disabled={isLoading}
					onChange={(event) => setSendEmail(event.target.checked)}
				/>
				<span>
					<span className="d-flex align-items-center gap-2 fw-semibold text-dark">
						<MdOutlineMarkEmailRead size={17} />
						Email me a summary
					</span>
					<span className="text-secondary small d-block mt-1">
						Sends a summary of this conversation to your account email.
					</span>
				</span>
			</label>
			) : null}
		</Modal>
	);
}
